module.exports = __webpack_public_path__ + "static/lookalikeYes-d975455c83dd28b8594b15002a7db619.png";